<template>
  <div class="overlay-child masking" :style="getSize()">
    <masked-text
      :text="maskedText"
      :max-dimensions="boundingBox"
      :zoom-factor="zoomFactor"
    />
    <div class="overlay-child masking-overlay" :style="getStyle()"></div>
  </div>
</template>
<script>
import { FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA } from '@/constants/colors';
import MaskedText from './MaskedText';

export default {
  components: {
    'masked-text': MaskedText,
  },
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    maskedText: {
      type: String,
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getStyle() {
      return {
        ...this.getSize(),
        background: FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA,
      };
    },
    getSize() {
      return {
        minHeight: `${this.boundingBox.height}px`,
        width: `${this.boundingBox.width}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.masking {
  display: block;
}
.masking-overlay {
  z-index: 50;
}
.overlay:hover {
  .masking {
    background: #fff;
  }
  .masking-overlay {
    z-index: 50;
    position: absolute;
    top: 0;
    left: 0;
  }
  .hidden-text {
    display: block;
    z-index: 100;
    padding: calc(var(--first-line-height) / 3);

    p:first-line {
      line-height: var(--first-line-height);
    }
  }
}
</style>
